<app-nav></app-nav>
<section class="polyclinic">
  <app-click-to-call></app-click-to-call>
  <div class="container">
    <div class="col">
      <div class="modal-body claim-pop text-center mt-4">
        <img
          src="../../assets/images/operation theatre.svg">
      </div>
      <p class="text-center"><b>Surgical Care</b></p>
      <p class="text-center"><span class="sub-title"></span> Get free video consultation with a reputed surgeon. Select the type of surgery below.
       <br> We will schedule a call with you, based on the availability of the Surgeon.
      </p>
      <p class="text-center">Following benefits are included in case of surgery in preferred partner hospitals</p>
      <p class="text-center" style="color:#F15A23"><span class="sub-title">*</span>available in selected cities</p>
      <div class="row mb-3" style="display: flex; justify-content: center;">
        <div class="Rectangle-2076 col-md-3"><img src="../../assets/images/Free room upgrade.svg" class="mr-1"><span>Free room upgrade</span></div>
        <div class="Rectangle-2076 col-md-3"><img src="../../assets/images/Cashless insurance claims.svg" class="mr-1"><span>Cashless insurance claims</span></div>
        <!-- <div class="Rectangle-2076 col-md-3"><img src="../../assets/images/Cashless insurance claims.svg" class="mr-1"><span>Not payable under insurance</span></div> -->
        <div class="Rectangle-2076 col-md-4"><img src="../../assets/images/Discounts.svg" class="mr-1"><span>Discounts on non-medical expenses</span></div>
      </div>
      <div class="ml-4 mr-4">
        <h6 class="spec-cat"><b>General Surgery</b></h6>
        <div class="text-center mb-4 ">
          <button class="btn btn-bordered-blue mt-2" (click)="bookAppointment('Gall Stones');">Gall Stones</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Gall Stones'" (click)="confirmAppointment('Gall Stones')" [disabled]="this.disable || this.hasEcard">Confirm</button>
          <button class="btn btn-bordered-blue mt-2" (click)="bookAppointment('Hernia');">Hernia</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Hernia'" (click)="confirmAppointment('Hernia')" [disabled]="this.disable || this.hasEcard">Confirm</button>
          <button class="btn btn-bordered-blue mt-2" (click)="bookAppointment('Hydrocele');">Hydrocele</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Hydrocele'" (click)="confirmAppointment('Hydrocele')" [disabled]="this.disable || this.hasEcard">Confirm</button>
        </div>
      </div>
      <div class="ml-4 mr-4">
        <h6 class="spec-cat"><b>Proctology</b></h6>
        <div class="text-center mb-4 ">
          <button class="btn btn-bordered-blue mt-2" (click)="bookAppointment('Anal Fissure');">Anal Fissure</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Anal Fissure'" (click)="confirmAppointment('Anal Fissure')" [disabled]="this.disable || this.hasEcard">Confirm</button>
          <button class="btn btn-bordered-blue mt-2" (click)="bookAppointment('Piles');">Piles</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Piles'" (click)="confirmAppointment('Piles')" [disabled]="this.disable || this.hasEcard">Confirm</button>
          <button class="btn btn-bordered-blue mt-2" (click)="bookAppointment('Anal Fistula');">Anal Fistula</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Anal Fistula'" (click)="confirmAppointment('Anal Fistula')" [disabled]="this.disable || this.hasEcard">Confirm</button>
        </div>
      </div> 
      <div class="ml-4 mr-4">
        <h6 class="spec-cat"><b>Ophthalmology</b></h6>
        <div class="text-center mb-4 ">
          <button class="btn btn-bordered-blue mt-2" (click)="bookAppointment('Cataract');">Cataract</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Cataract'" (click)="confirmAppointment('Cataract')" [disabled]="this.disable || this.hasEcard">Confirm</button>
          <button class="btn btn-bordered-blue mt-2" (click)="bookAppointment('Glaucoma');">Glaucoma</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Glaucoma'" (click)="confirmAppointment('Glaucoma')" [disabled]="this.disable || this.hasEcard">Confirm</button>
        </div>
      </div>  
      <div class="ml-4 mr-4">
        <h6 class="spec-cat"><b>Gynaecology</b></h6>
        <div class="text-center mb-4 ">
          <button class="btn btn-bordered-blue mt-2" (click)="bookAppointment('Ovarian Cyst');">Ovarian Cyst</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Ovarian Cyst'" (click)="confirmAppointment('Ovarian Cyst')" [disabled]="this.disable || this.hasEcard">Confirm</button>
          <button class="btn btn-bordered-blue mt-2" (click)="bookAppointment('Hysterectomy');">Hysterectomy</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Hysterectomy'" (click)="confirmAppointment('Hysterectomy')" [disabled]="this.disable || this.hasEcard">Confirm</button>
        </div>
      </div> 
      <div class="ml-4 mr-4">
        <h6 class="spec-cat"><b>Urology</b></h6>
        <div class="text-center mb-4 ">
          <button class="btn btn-bordered-blue mt-2" (click)="bookAppointment('Kidney Stone');">Kidney Stone</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Kidney Stone'" (click)="confirmAppointment('Kidney Stone')" [disabled]="this.disable || this.hasEcard">Confirm</button>
          <button class="btn btn-bordered-blue mt-2" (click)="bookAppointment('Renal Cyst');">Renal Cyst</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Renal Cyst'" (click)="confirmAppointment('Renal Cyst')" [disabled]="this.disable || this.hasEcard">Confirm</button>
        </div>
      </div>
      <div class="ml-4 mr-4">
        <h6 class="spec-cat"><b>Orthopaedics</b></h6>
        <div class="text-center mb-4 ">
          <button class="btn btn-bordered-blue mt-2" (click)="bookAppointment('Knee Replacement');">Knee Replacement</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Knee Replacement'" (click)="confirmAppointment('Knee Replacement')" [disabled]="this.disable || this.hasEcard">Confirm</button>
          <button class="btn btn-bordered-blue mt-2" (click)="bookAppointment('Hip Replacement');">Hip Replacement</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Hip Replacement'" (click)="confirmAppointment('Hip Replacement')" [disabled]="this.disable || this.hasEcard">Confirm</button>
        </div>
      </div>
      <!-- <div class="ml-4 mr-4">
        <h6 class="spec-cat"><b>Cosmetic Surgery</b></h6>
        <div class="text-center mb-4 ">
          <button class="btn btn-bordered-blue mt-2" (click)="bookAppointment('Lasik Surgery');">Lasik Surgery</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Lasik Surgery'" (click)="confirmAppointment('Lasik Surgery')" [disabled]="this.disable || this.hasEcard">Confirm</button>
          <button class="btn btn-bordered-blue mt-2" (click)="bookAppointment('Tooth Aligners');">Tooth Aligners</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Tooth Aligners'" (click)="confirmAppointment('Tooth Aligners')" [disabled]="this.disable || this.hasEcard">Confirm</button>
          <button class="btn btn-bordered-blue mt-2" (click)="bookAppointment('Liposuction');">Liposuction</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Liposuction'" (click)="confirmAppointment('Liposuction')" [disabled]="this.disable || this.hasEcard">Confirm</button>
        </div>
      </div> -->
      <div class="ml-4 mr-4">
        <h6 class="spec-cat"><b>Others</b></h6>
        <div class="text-center mb-4 ">
          <button class="btn btn-bordered-blue mt-2" (click)="bookAppointment('Others');">Others</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Others'" (click)="confirmAppointment('Others')" [disabled]="this.disable || this.hasEcard">Confirm</button>
        </div>
      </div>      
      <!-- <p class="text-center">If you want to book the appointment immediately then you can avail 15% discount on online consultation. Click below.</p>
      <div class="ml-4 mr-4">
        <div class="text-center mb-4 ">
          <div class="col-12" style="display: block" (click)="redirectToMfine()">       
              <div class="col-12"><div class="product-icon">
                <span class="icon icon-homeloan"></span>
              </div></div>
              <div class="text-center col-12"><label class="product-title">Consult Doctor Online</label></div>
          </div>
        </div> -->
        <!-- </div>
      -->
    </div>

  </div>
  <div class="modal fade" id="thankyou" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body claim-pop text-center mt-4">
          <img
            src="../../assets/images/Thank you Doctor Illustrator.svg">
        </div>
        <div class="text-center ml-4 mr-4">
          <p>Thank you!</p>
          <p>
            We will schedule a counsellor for an appointment with the Surgeon</p>
        </div>
        <div class="text-center ml-4 mr-4 mb-4">
          <button type="button" class="btn btn-blue" data-dismiss="modal" routerLink="/home">Done</button>
        </div>
      </div>
    </div>
  </div>
</section>

<div id="spinner" [hidden]="!loading">
  <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
</div>